import React, { FC }                from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Icon }             from "semantic-ui-react";
import UpdateCustomer               from "../../../application/usecase/customer/UpdateCustomer";
import Customer                     from "../../../domain/customer/Customer";
import { ResKaState }               from "../../../index";

const CustomerUpdateButton: FC = () => {
  const customer: Customer = useSelector((state: ResKaState) => state.customer);
  const updateCustomer: UpdateCustomer = new UpdateCustomer(useDispatch());
  return (
    <>
      <Button
        icon
        labelPosition="left"
        positive
        onClick={ () => updateCustomer.execute(customer) }
      >
        <Icon name="save"/>
        保存する
      </Button>
    </>
  );
};

export default CustomerUpdateButton;
